module.exports = __webpack_public_path__ + "static/media/login_footer_plate.b0565eed.png";